import { clearHelixCache } from '@/plugins/dexie';
import { clearHelixRuntimeState } from '@/utils/clear-helix-runtime-state';

const CACHE_CLEAR_TIMEOUT_MS = 2000;

/**
 * Clears IndexedDB + in-memory cache before leaving the session.
 * Safe to call from top-bar logout and from the logout page (idempotent).
 * Never blocks logout for more than {@link CACHE_CLEAR_TIMEOUT_MS}.
 *
 * Runtime state is cleared after the race so a timed-out IDB clear cannot
 * re-populate in-memory settings before navigation.
 */
export async function clearHelixCacheOnLogout(): Promise<void> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  try {
    await new Promise<void>((resolve) => {
      timeoutId = setTimeout(resolve, CACHE_CLEAR_TIMEOUT_MS);

      void clearHelixCache()
        .catch((error) => {
          console.warn('[cache] clearHelixCache threw during logout; continuing:', error);
        })
        .finally(() => {
          if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
            timeoutId = undefined;
          }
          resolve();
        });
    });
  } catch (error) {
    console.warn('[cache] clearHelixCacheOnLogout unexpected error; continuing:', error);
  } finally {
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }
  }

  clearHelixRuntimeState();
}
